<template>
  <div class="card-title">
    <el-icon :size="20">
      <svg-icon :name="icon" />
    </el-icon>
    <slot></slot>
  </div>
</template>

<script setup>
defineProps({
  icon: {
    type: String,
  }
})
</script>

<style lang="scss" scoped>
.card-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 10px 0 27px;
  font-size: 18px;
  font-weight: 600;
  color: #222;
  line-height: 21px;
}
</style>